import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { InstitutionClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.EnteQuery],
  create: [SystemAuthorizations.EnteAdd],
  edit: [SystemAuthorizations.EnteUpdate],
  delete: [SystemAuthorizations.EnteDelete],
});

export const headCells: HeadCell<InstitutionClient, keyof InstitutionClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'istat',
    label: 'ISTAT',
  },
  {
    id: 'province',
    label: 'Provincia',
  },
  // {
  //   id: 'type',
  //   label: 'ANPR',
  // },
  {
    id: 'officeNumber',
    label: 'Numero ufficio Stato Civile',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaInstitutionFilter = yup.object({
  istat: yup.string().notRequired().nullable().min(6, 'Minimo 6 cifre').max(6, 'Massimo 6 cifre'),
  officeNumber: yup
    .number()
    .nullable()
    .notRequired()
    .max(2147483647, 'Il campo supera il range massimo che è di 2147483647'), // max value integer java
});
